import { Grid, Paper, styled } from "@mui/material";
const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "left",
  color: theme.palette.text.secondary,
  border: "0px",
  boxShadow: "none"
}));
export default function SearchDetailItem({searchItemValue, label}) {

  return (
        <Grid item xs={4}>
          <Item><b>{label}</b></Item>
          <Item>{searchItemValue}</Item>
        </Grid>
  );
};
